export default class GoogleAnalyticsService {
  static init(gaId='G-QNNFJ1HF3Z') {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    // gtag'i başlat
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', gaId);

    window.gtag = gtag;
  }

  static trackPageView(page) {
    if (window.gtag) {
      window.gtag('config', 'G-QNNFJ1HF3Z', {
        page_path: page
      });
    }
  }
} 